import { Util } from '@grandvisionhq/forms';

const validateInputField = (required, value, validations, maxLengthValue)=>{
    if (!required && value.length === 0) {
        return true;
    }
    if (required) {
        if (!Util.validations.isRequired(value)) {
            return false;
        }
    }
    if (maxLengthValue && !Util.validations.maxLength(maxLengthValue)(value)) {
        return false;
    }
    if (validations) {
        return validations.reduce((isValid, validator)=>validator(value) && isValid
        , true);
    }
    return true;
};

export { validateInputField };
//# sourceMappingURL=validate-input-field.js.map
